export class DateUtils {

  public static getDuration(time: number): string {
    let days = 0;
    let hours = 0;
    let minutes = 0;
    let seconds = 0;
    let miliseconds = 0;

    days = Math.floor(time / 86400000);
    time = time % 86400000;

    hours = Math.floor(time / 3600000);
    time = time % 3600000;

    minutes = Math.floor(time / 60000);
    time = time % 60000;

    seconds = Math.floor(time / 1000);
    time = time % 1000;

    miliseconds = Math.floor(time);

    const date = new Date();

    if (days > 0) { return days + 'd ' + hours + 'h'; } else {
      if (hours > 0) { return hours + 'h ' + minutes + 'm'; } else {
        if (minutes > 0) { return minutes + 'm ' + seconds + 's'; } else {
          if (seconds === 0 && miliseconds === 0) { return '0m 0s'; } else {
            return seconds + 's ' + miliseconds + 'ms';
          }
        }
      }
    }
  }
}
